'use client';

import { Typography, type TypographyProps } from '@mui/material';

import { useAppDisplayVersion } from './use-app-display-version';

interface Props extends TypographyProps {
  showPrefix?: boolean;
}

export const AppVersion: React.FC<Props> = ({ sx, showPrefix = true }) => {
  const version = useAppDisplayVersion();

  return (
    <Typography
      aria-label={`Versão do aplicativo ${version}`}
      sx={{
        fontSize: 12,
        color: ({ palette }) => palette.text.secondary,
        textAlign: 'right',
        fontWeight: 'bold',
        ...sx,
      }}
    >
      {showPrefix ? 'v.' : ''}
      {version}
    </Typography>
  );
};
